export const atlas = {
  // HEADER
  'atlas.header.name': 'Atlas&nbsp;cen',
  'atlas.meta.title': 'Atlas cen',
  'atlas.meta.description':
    'Atlas cen je aplikace, která ukazuje reálné prodejní ceny nemovitostí přehledně na mapě.',

  // DESKTOP FILTERS
  'atlas.filters.type': 'Typ nemovitostí',
  'atlas.filters.pointer_type.flat': 'Byty',
  'atlas.filters.pointer_type.building': 'Domy',
  'atlas.filters.pointer_type.other': 'Ostatní',
  'atlas.filters.disabled_tooltip': 'Připravujeme',
  'atlas.filters.price_per_square_meter.default_placeholder': 'Cena za m²',
  'atlas.filters.price_per_square_meter.min_max_placeholder':
    '{min} - {max} Kč/m²',
  'atlas.filters.price_per_square_meter.min_placeholder': '{min} - ∞ Kč/m²',
  'atlas.filters.price_per_square_meter.max_placeholder': '0 - {max} Kč/m²',
  'atlas.filters.price_per_square_meter.placeholders': 'libovolná',
  'atlas.filters.area.default_placeholder': 'Výměra',
  'atlas.filters.area.min_max_placeholder': '{min} - {max} m²',
  'atlas.filters.area.min_placeholder': '{min} - ∞ m²',
  'atlas.filters.area.max_placeholder': '0 - {max} m²',
  'atlas.filters.area.placeholders': 'libovolná',
  'atlas.filters.area.1kk': '1+kk',
  'atlas.filters.area.2kk': '2+kk',
  'atlas.filters.area.3kk': '3+kk',
  'atlas.filters.area.4kk': '4+kk',
  'atlas.filters.mobile.tab': 'Filtry',
  'atlas.filters.mobile.submit': 'Potvrdit',
  'atlas.filters.mobile.dismiss': 'Smazat vše',
  'atlas.filters.date.from.last_month': 'Poslední měsíc',
  'atlas.filters.date.from.last_three_months': 'Poslední 3 měsíce',
  'atlas.filters.date.from.last_six_months': 'Posledních 6 měsíců',
  'atlas.filters.date.from.last_nine_months': 'Posledních 9 měsíců',
  'atlas.filters.date.from.last_year': 'Poslední rok',
  'atlas.filters.date.from.last_two_years': 'Poslední 2 roky',
  'atlas.filters.date.from.own_date': 'Vlastní',
  'atlas.filters.date.default_placeholder': 'Datum prodeje',
  'atlas.filters.date.placeholder': 'Od {date}',
  'atlas.filters.date.mobile.button': 'Vybrat datum',
  'atlas.filters.date.mobile.button.date_selected': 'Od {date}',
  'atlas.filters.date.mobile.button.close_modal': 'Potvrdit',
  'atlas.filters.date.dismiss': 'Zrušit omezení',
  'atlas.filters.date.submit': 'Hotovo',
  'atlas.filters.date.mobile.clear_filters': 'Zrušit výběr data',

  'atlas.filters.mobile.sorting.tab': 'Řazení',
  'atlas.filters.mobile.sorting.title': 'Seřadit podle',
  'atlas.filters.mobile.sorting.sales_with_photos': 'Prodeje s fotkou',
  'atlas.filters.mobile.sorting.latest_sales': 'Nejnovější',
  'atlas.filters.mobile.sorting.lowest_price': 'Nejlevnější',
  'atlas.filters.mobile.sorting.highest_price': 'Nejdražší',

  // INFO TABLE
  'atlas.info_table.unknown': 'Nezjištěno',
  'atlas.info_table.area': '{area}&nbsp;m<sup>2</sup>',
  'atlas.info_table.yes': 'Ano',
  'atlas.info_table.no': 'Ne',

  // FILTER TOOLTIP
  'atlas.filter.tooltip.text':
    'Mezi ostatní patří např. pozemky, komerční budovy, garáže a garážová stání a další.',
  // OFFER SECTION
  'atlas.offer_section.title': 'Přemýslíte o prodeji nemovitosti?',
  'atlas.offer_section.perex':
    'Nejsme realitka. Prodáme vaší nemovitost<br />za dobrou cenu.',
  'atlas.offer_section.button': 'Chci bezplatnou nabídku',

  // SUBSCRIBE SECTION
  'atlas.subscribe_section.title':
    'Nastavte si pravidlené sledování<br />cen ve vaší lokalitě',
  'atlas.subscribe_section.subtitle':
    'Pošleme vám email pokud se ve vaší<br />lokalitě něco změní.',
  'atlas.subscribe_section.saving': 'Ukládám...',
  'atlas.subscribe_section.saved': 'E-mail byl úspěšně uložen',
  'atlas.subscribe_section.disclaimer':
    'Potvrzením souhlasíte s všeobecnými podmínkami.<br />Můžete se kdykoliv odhlásit.',
  'atlas.subscribe_section.set': 'Nastavit',
  'atlas.subscribe_section.back': 'Zpět na mapu',
  'atlas.subscribe_section.error': 'Vyplňte prosím platný e-mail',
  'atlas.subscribe_section.placeholder': 'Váš e-mail',

  // SUBSCRIBE MODAL
  'atlas.subscribe_modal.openButton': 'Hlídat ceny',
  'atlas.subscribe_modal.title.default': 'Uložení hlídání cen',
  'atlas.subscribe_modal.title.exit': 'Nezapomeňte si uložit hlídání',
  'atlas.subscribe_modal.subtitle.exit':
    'Chcete vědět, co nového se prodalo ve vašem okolí? Přehled novinek vám pošleme <strong>bezplatně jednou měsíčně emailem</strong>.',
  'atlas.subscribe_modal.subtitle.default':
    'Nastavte si hlídání cen a prodaných nemovitostí ve vašem okolí. Přehled novinek vám pošleme jednou měsíčně e-mailem.',
  'atlas.subscribe_modal.map_instruction':
    '<strong>Jak na to?</strong> Pohybem po mapce upřesníte lokalitu a pomocí tlačítek +/- vyberte rozsah oblasti, kterou chcete hlídat.',
  'atlas.subscribe_modal.saving': 'Ukládám...',
  'atlas.subscribe_modal.saved': 'E-mail byl úspěšně uložen',
  'atlas.subscribe_modal.set': 'Nastavit',
  'atlas.subscribe_modal.back': 'Zpět na mapu',
  'atlas.subscribe_modal.error': 'Vyplňte prosím platný e-mail',
  'atlas.subscribe_modal.placeholder': 'váš@email.cz',
  'atlas.subscribe_modal.inputLabel': 'E-mail',
  'atlas.subscribe_modal.button': 'Nastavit hlídání',
  'atlas.subscribe_modal.address': 'Uložená adresa: <strong>{search}</strong>',
  'atlas.subscribe_modal.radioLabel': 'Vyberte okruh hlídání',
  'atlas.subscribe_modal.radius1radio': 'Okolí adresy',
  'atlas.subscribe_modal.radius2radio': 'Ulici',
  'atlas.subscribe_modal.radius3radio': 'Městskou část',
  'atlas.subscribe_modal.radius4radio': 'Město',
  'atlas.subscribe_modal.thankYou__title': 'Hotovo',
  'atlas.subscribe_modal.thankYou__subtitle':
    'Brzy se můžete těšit na aktuální informace o prodejích a cenách ve vašem okolí.',
  'atlas.subscribe_modal.thankYou__button': 'Zavřít',
  'atlas.subscribe_modal.addressValidation':
    'Zadejte adresu lokality, kterou chcete sledovat, ve formátu např. Jankovcova 45 nebo Praha Holešovice.',
  'atlas.subscribe_modal.max_zoom':
    'Nelze hlídat větší oblast, než je nyní nastavena.',

  // SIDEBAR FOOTER
  'atlas.sidebar_footer.send': 'Poslat zpětnou vazbu',

  // PROPERTY POP CONTENT
  'atlas.property_pop_up.paging': '{page}/{maxPage}',
  'atlas.property_pop_up.price': '{price} Kč',
  'atlas.property_pop_up.price_per_square': '{price} Kč / m²',
  'atlas.property_pop_up.': '{area} m²',
  'atlas.property_pop_up.date': 'Datum zápisu:',
  'atlas.property_pop_up.unit': 'Číslo jednotky:',
  'atlas.property_pop_up.building_number': 'Číslo stavby:',
  'atlas.property_pop_up.transfer_id': 'Číslo řízení v CÚZK:',

  // MOBILE MAP SETTINGS
  'atlas.map_settings.type': 'Typ nemovitostí',
  'atlas.map_settings.flat': 'Byty',
  'atlas.map_settings.building': 'Domy',
  'atlas.map_settings.other': 'Ostatní',
  'atlas.map_settings.show_map': 'Zobrazení mapy',
  'atlas.map_settings.normal': 'Základní',
  'atlas.map_settings.satellite': 'Satelitní',

  // MAP ATTRIBUTION
  'atlas.map.attribution.terms': 'Smluvní podmínky',
  'atlas.map.attribution.privacy': 'Ochrana soukromí',

  // SHARE
  'atlas.share.text': 'Odkaz&nbsp;zkopírován',

  // SEARCH
  'atlas.search.no_results': 'Žádné výsledky',
  'atlas.search.placeholder': 'Zadejte adresu',
  'atlas.search.position_on_map': 'Pozice na mapě',

  // SECTIONS - SIDEBAR/MOBILE BAR
  'atlas.top_bar.filters': 'Filtry / řazení',
  'atlas.estates_subscribe.text':
    'Chcete vědět, co se prodalo <br />ve vašem okolí?',
  'atlas.estates_subscribe.button': 'Uložit hledání',
  'atlas.zero_estates.title':
    'V této oblasti neevidujeme žádné prodané nemovitosti.',
  'atlas.zero_estates.title.selected_address':
    'Na této adrese ani v okolí neevidujeme žádné prodané nemovitosti.',
  'atlas.zero_estates.text': 'Zkuste prosím změnit zadání nebo oddálit mapu.',
  'atlas.zero_estates.title_filter':
    'Vypadá to, že vybranému filtru neodpovídají žádné nemovitosti na mapě.',
  'atlas.zero_estates.text_filter': 'Odstraňte filtry nebo oddalte mapu.',
  'atlas.zero_estates.button_remove_filters': 'Odstranit filtry',
  'atlas.zero_estates.button_zoom_out': 'Oddálit mapu',
  'atlas.estate_not_found.text':
    'Na této adrese neevidujeme žádnou prodanou nemovitost.',
  'atlas.estate_found.text': `Našli jsme zde {addressEstatesCount} {addressEstatesCount, plural,
      one {prodanou}
      few {prodané}
      other {prodaných}
    } {addressEstatesCount, plural,
      one {nemovitost}
      few {nemovitosti}
      other {nemovitostí}
    }`,
  'atlas.estates_on_map': `{count} {count, plural,
      one {prodaná nemovitost}
      few {prodané nemovitosti}
      other {prodaných nemovitostí}
    }`,
  'atlas.building_detail.flats_in_building': `{count} {count, plural,
      one {prodaný byt}
      few {prodané byty}
      other {prodaných bytů}
    }`,
  'atlas.building_detail.no_flats_in_building':
    'V tomto domě neevidujeme žádné prodeje bytů.',
  'atlas.building_detail.no_flats_in_building.filtered':
    'V tomto domě neevidujeme žádné prodeje bytů vyhovující vašemu filtru.',
  'atlas.building_detail.no_processed_estates_on_address':
    'Na této adrese momentálně neevidujeme žádnou prodanou nemovitost.',
  'atlas.building_detail.other_estates_on_map': `{count, plural,
      one {Další {count} prodaná nemovitost}
      few {Další {count} prodané nemovitosti}
      other {Dalších {count} prodaných nemovitostí}
    } na mapě`,
  'atlas.building_detail.cadastre_link':
    'Zobrazit stavbu v Katastru nemovitostí >',
  'atlas.building_detail.panorama': 'Panorama',
  'atlas.building_detail.panorama.fullscreen': 'Zvětšit',
  'atlas.building_detail.map': 'Mapa',
  'atlas.building_detail.related_units': 'Jednotky v budově',
  'atlas.building_detail.related_units.find_unit': 'Vyhledat jednotku',
  'atlas.building_detail.related_units.search_info':
    'Vyhledejte svou jednotku podle <b>čísla</b>:',
  'atlas.building_detail.related_units.search.placeholder': 'např. 123/456',
  'atlas.building_detail.related_units.show_more':
    'Zobrazit další ({remainingUnits})',
  'atlas.building_detail.related_units.wrap': 'Sbalit seznam',
  'atlas.building_detail.related_units.no_units_found':
    'Nebyly nalezeny žádné jednotky.',
  'atlas.show_properties.text': 'Zobrazit seznam',
  'atlas.show_map.text': 'Zobrazit mapu',
  'atlas.show_detail.text': 'Zobrazit detail',

  'atlas.cta.title': 'Zvažujete prodej nemovitosti?',
  'atlas.cta.subtitle':
    'Nechte si nezávazně spočítat, za kolik ji od vás koupíme my. Jednoduše a rychle.',
  'atlas.cta.button': 'Získat cenovou nabídku',
  'atlas.pages_count': 'Nemovitostí na stránce',

  // MAP POINTER LIST SORT
  'atlas.sorting': 'Seřadit podle',
  'atlas.sorting.sales_with_photos': 'Prodeje s fotkou',
  'atlas.sorting.latest_sales': 'Nejnovější',
  'atlas.sorting.lowest_price': 'Nejlevnější',
  'atlas.sorting.highest_price': 'Nejdražší',
  // BROKER BANNER
  'atlas.broker_banner.image_label': 'Jste makléř? Ukažte se!',
  'atlas.broker_banner.cta_text':
    'Buďte vidět díky vaším prodejům. Registrujte se zdarma.',
  'atlas.broker_banner.cta_button': 'Chci být vidět',

  // CTA SUBSCRIBE BOX
  'atlas.cta_subscribe.title': 'Chcete vědět, co se prodalo ve vašem okolí?',
  'atlas.cta_subscribe.subtitle':
    'Nechte si pravidelně posílat přehled o tom, co se v okolí prodalo.',

  // FAQ
  'atlas.faq_section.button': 'O Atlasu cen',
  'atlas.faq_section.icon': 'i',

  // FEEDBACK
  'atlas.feedback_section.button': 'Poslat nápad na vylepšení',
  'atlas.feedback_section.title': 'Pomozte nám být lepší',
  'atlas.feedback_section.subtitle':
    'Máte pro nás tip nebo se vám něco nezdá? Napište nám.',
  'atlas.feedback_section.email': 'E-mail',
  'atlas.feedback_section.email.placeholder': 'váš@email.cz',
  'atlas.feedback_section.message': 'Zpráva',
  'atlas.feedback_section.message.placeholder': 'Zanechte nám vzkaz…',
  'atlas.feedback_section.feedback_button': 'Odeslat',
  'atlas.feedback_section.success': 'Děkujeme ',
  'atlas.feedback_section.success_subtitle': 'Zpráva byla úspěšně odeslána.',
  'atlas.feedback_section.success_button': 'Zavřít',

  // ESTATE ITEM
  'atlas.estate_item.top_bar.sold_at': 'Prodáno {soldAt, date, medium}',
  'atlas.estate_item.top_bar.labels.new': 'Nové',
  'atlas.estate_item.top_bar.labels.hidden': 'Skrytý',
  'atlas.estate_item.info.flat_disposition.atypic': 'atypický',
  'atlas.estate_item.info.area': '{area} m<sup>2</sup>',
  'atlas.estate_item.info.area_interval': '{areaFrom}-{areaTo} m<sup>2</sup>',
  'atlas.estate_item.info.price_per_square_m': '{price}/m<sup>2</sup>',

  // Estate types inside ESTATE ITEM
  // Building
  'atlas.estate_item.info.estate_type.building.apartment_building': 'Dům',
  'atlas.estate_item.info.estate_type.building.housing': 'Dům',
  'atlas.estate_item.info.estate_type.building.family_house': 'Dům',
  'atlas.estate_item.info.estate_type.building.industrial_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.farm_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.amenities': 'Budova',
  'atlas.estate_item.info.estate_type.building.forestry_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.recreational_building': 'Dům',
  'atlas.estate_item.info.estate_type.building.gathering_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.accommodation_building':
    'Budova',
  'atlas.estate_item.info.estate_type.building.warehouse': 'Budova',
  'atlas.estate_item.info.estate_type.building.bussiness_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.office_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.paraphernalia_building':
    'Budova',
  'atlas.estate_item.info.estate_type.building.agricultural_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.transport_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.garage_building': 'Budova',
  'atlas.estate_item.info.estate_type.building.other': 'Budova',
  'atlas.estate_item.info.estate_type.building.multifunctional_building':
    'Budova',
  'atlas.estate_item.info.estate_type.building.greenhouse': 'Budova',
  'atlas.estate_item.info.estate_type.building.dam': 'Budova',
  'atlas.estate_item.info.estate_type.building.flood_barrier': 'Budova',
  'atlas.estate_item.info.estate_type.building.river_dam': 'Budova',
  'atlas.estate_item.info.estate_type.building.water_reservoir': 'Budova',
  'atlas.estate_item.info.estate_type.building.water_or_sailing_building':
    'Budova',
  'atlas.estate_item.info.estate_type.building.hydropower_plant': 'Budova',
  'atlas.estate_item.info.estate_type.building.barrage': 'Budova',
  'atlas.estate_item.info.estate_type.building.tailings_dam': 'Budova',
  'atlas.estate_item.info.estate_type.building.unfinished': 'Nedokončený dům',
  'atlas.estate_item.info.estate_type.building.unknown': 'Ostatní',

  // Unit
  'atlas.estate_item.info.estate_type.unit.flat': 'Byt',
  'atlas.estate_item.info.estate_type.unit.studio': 'Studio',
  'atlas.estate_item.info.estate_type.unit.garage': 'Garáž',
  'atlas.estate_item.info.estate_type.unit.workshop': 'Ostatní',
  'atlas.estate_item.info.estate_type.unit.commertial_space': 'Kom. prostor',
  'atlas.estate_item.info.estate_type.unit.mixed_flats': 'Ostatní',
  'atlas.estate_item.info.estate_type.unit.mixed_commertial_spaces': 'Ostatní',
  'atlas.estate_item.info.estate_type.unit.mixed': 'Ostatní',
  'atlas.estate_item.info.estate_type.unit.unknown': 'Ostatní',
  'atlas.estate_item.info.estate_type.unit.unfinished': 'Nedokončená jednotka',

  // Parcel
  'atlas.estate_item.info.estate_type.parcel.fertile_ground': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.hop_garden': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.vineyard': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.garden': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.orchard': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.pernament_grassland': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.forest_land': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.water_area': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.builtup_area_and_courtyard':
    'Parcela',
  'atlas.estate_item.info.estate_type.parcel.other_area': 'Parcela',
  'atlas.estate_item.info.estate_type.parcel.unknown': 'Ostatní',

  // Generic

  // Suggestion
  'atlas.suggestion.district': `Okres {district}`,

  // atlas link to cuzk redirect page
  'atlas_cuzk_detail.transfer.loading': 'Načítání odkazu na vlastníky',
  'atlas_cuzk_detail.building.loading': 'Načítání odkazu na detail stavby',
  'atlas_cuzk_detail.parcel.loading': 'Načítání odkazu na detail parcely',
  'atlas_cuzk_detail.unit.loading': 'Načítání odkazu na detail jednotky',
  'atlas_cuzk_detail.error.title': 'Služba je momentálně nedostupná.',
  'atlas_cuzk_detail.error.subtitle': 'Zkuste to, prosím, později.',

  // Tooltip
  'atlas.tooltip.text': '{price} / m<sup>2</sup>',

  // Sidebar price calculator
  'atlas.price_calculator.title': 'Kalkulačka ceny nemovitosti',
  'atlas.price_calculator.not_available.title':
    'Kalkulačka ceny nemovitosti není dostupná',
  'atlas.price_calculator.not_available.subtitle':
    'Pro zobrazení kalkulačky přibližte mapu.',
  'atlas.price_calculator.not_available.button.zoom_in': 'Přiblížit mapu',
  'atlas.price_calculator.title.result':
    'Cenový odhad bytu o velikosti {area} m<sup>2</sup>',
  'atlas.price_calculator.perex':
    'Cenu vypočítáme z průměrné ceny za m<sup>2</sup> a výměry bytu.',
  'atlas.price_calculator.price': 'Průměrná cena: {price} / m<sup>2</sup>',
  'atlas.price_calculator.calculate': 'Vypočítat cenu',
  'atlas.price_calculator.input.placeholder': 'Zadejte výměru',
  'atlas.price_calculator.input.required': 'Výměra nemůže být prázdná',
  'atlas.price_calculator.input.min': 'Výměra nemůže být nulová nebo záporná',
  'atlas.price_calculator.result.price_per_m': '{price} / m<sup>2</sup>',
  'atlas.price_calculator.reset': 'Resetovat',

  // Parcel detail
  'atlas.parcel_detail.parcel_type': '{parcelType}',
  'atlas.parcel_detail.parcel_type_with_area':
    '{parcelType}, {area}&nbsp;m<sup>2</sup>',
  'atlas.parcel_detail.cadastral_area': 'Katastrální území {cadastralArea}',
  'atlas.parcel_detail.parcel_number': 'Parcelní číslo {number}',
  'atlas.parcel_detail.cadastre_link':
    'Zobrazit parcelu v katastru nemovitostí &gt;',
  'atlas.parcel_detail.bottom_bar.subtitle.municipality_with_parcel_number':
    'Parc. č. {parcelNumber}, {municipality}',

  // Unit detail
  'atlas.unit_detail.title.unit_disposition': '&nbsp;{disposition}',
  'atlas.unit_detail.title.unit_number': '&nbsp;(č. {buildingNumber}/{number})',

  'atlas.unit_detail.last_sale.heading': 'Poslední prodej',
  'atlas.unit_detail.last_sale.sold_for': 'Prodáno za',
  'atlas.unit_detail.last_sale.price_per_square_meter_started_at':
    'Počáteční cena',
  'atlas.unit_detail.last_sale.price_per_square_meter':
    '{pricePerSquareM}&nbsp;Kč/m<sup>2</sup>',
  'atlas.unit_detail.last_sale.price_dropped_by': 'Sleva při prodeji',
  'atlas.unit_detail.last_sale.discount': '{discount}&nbsp;%',
  'atlas.unit_detail.last_sale.appeared_on_market': 'Zahájení prodeje',
  'atlas.unit_detail.last_sale.sold_date': 'Prodáno',
  'atlas.unit_detail.last_sale.sale_duration': 'Doba prodeje',
  'atlas.unit_detail.unit_number':
    'Číslo jednotky: <b>{buildingNumber}/{number}</b>',
  'atlas.unit_detail.cadastre_link':
    'Zobrazit jednotku v Katastru nemovitostí&nbsp;>',
  // unit dispositions for unit detail title
  'atlas.unit_detail.title.unit_disposition.larger': '&nbsp;5+kk a větší',
  'atlas.unit_detail.title.unit_disposition.atypic': '&nbsp;Atypický',

  // unit dispositions
  'atlas.unit_detail.disposition.larger': '5+kk a větší',
  'atlas.unit_detail.disposition.atypic': 'Atypická',

  // atlas unit detail photos
  'atlas.unit_detail.photos.tab_name': 'Fotky',
  'atlas.unit_detail.photos.title': 'Zpřesnit cenový odhad',
  'atlas.unit_detail.photos.text':
    'Nahrajte fotky kuchyně a koupelny a zpřesněte si cenový odhad až o <b>15%</b>!',

  // atlas unit image upload modal
  'atlas.unit_image_upload_modal.step.upload.title':
    'Zpřesněte si odhad až o 15% nahráním fotek',
  'atlas.unit_image_upload_modal.step.upload.steps.1':
    'Nahrajte fotky <b>koupelny</b> a <b>kuchyně</b>.',
  'atlas.unit_image_upload_modal.step.upload.steps.2':
    'Z fotek <b>rozpoznáme stav</b> i o jakou místnost se jedná.',
  'atlas.unit_image_upload_modal.step.upload.steps.3':
    '<b>Přesnější odhad</b> ceny získáte <b>ihned</b>.',
  'atlas.unit_image_upload_modal.step.upload.disclaimer':
    'Fotografie slouží pouze ke zpřesnění cenového odhadu a nebudou na webu publikovány.',
  'atlas.unit_image_upload_modal.step.upload.upload_section.drop_area.title':
    'Klikněte pro výběr fotek',
  'atlas.unit_image_upload_modal.step.upload.upload_section.drop_area.text':
    'nebo sem přetáhněte fotky ze svého počítače',
  'atlas.unit_image_upload_modal.step.upload.upload_section.title':
    'Můžete nahrát 2 - 9 fotek',
  'atlas.unit_image_upload_modal.step.upload.upload_section.inline_upload.text':
    'Přidat další',
  'atlas.unit_image_upload_modal.step.upload.upload_section.error':
    'Některé fotky jsou příliš malé nebo je nelze zpracovat. Minimální rozměr je 300×300 px.',

  // unit image upload results
  'atlas.unit_image_upload_modal.step.results.title':
    'Rozpoznaný stav místností',
  'atlas.unit_image_upload_modal.step.results.subtitle':
    'Stačí jeden klik a zjištěný stav promítneme do cenového odhadu byt. jednotky.',
  'atlas.unit_image_upload_modal.cancel': 'Zrušit',
  'atlas.unit_image_upload_modal.step.upload.cta': 'Pokračovat',
  'atlas.unit_image_upload_modal.step.loading.cta': 'Probíhá zpracování',
  'atlas.unit_image_upload_modal.step.results.cta': 'Zpřesnit odhad',
  'atlas.unit_image_upload_modal.step.results.other_rooms': 'Další místnosti',
  'atlas.unit_image_upload_modal.thermometer.condition.bad': 'Špatný',
  'atlas.unit_image_upload_modal.thermometer.condition.good': 'Dobrý',
  'atlas.unit_image_upload_modal.thermometer.condition.newish': 'Zánovní',
  'atlas.unit_image_upload_modal.thermometer.condition.excellent': 'Výborný',
  'atlas.unit_image_upload_modal.thermometer.condition.not_available':
    'Nedostupný',
  'atlas.unit_image_upload_modal.thermometer.condition.not_available.info':
    'Stav zatím není k dispozici.',

  // unit image upload loading errors
  'atlas.unit_image_upload_modal.step.error.cta': 'Zkusit znovu',
  'atlas.unit_image_upload_modal.step.error.title': 'Došlo k chybě',
  'atlas.unit_image_upload_modal.step.error.recognition_failed.message':
    'Rozpoznávání místností se nezdařilo. Buď se nám nepodařilo rozpoznat žádnou kuchyň, či koupelnu, nebo došlo k neznámé chybě.<br></br><br></br>Zkontolujte prosím své fotky a zkuste to znovu.',
  'atlas.unit_image_upload_modal.step.error.estimate_generation_failed.message':
    'Vytváření odhadu selhalo, zkuste to prosím znovu.',

  // unit image upload loading
  'atlas.unit_image_upload_modal.step.loading.room_recognition.title':
    'Probíhá rozpoznávání fotek…',
  'atlas.unit_image_upload_modal.step.loading.estimate_generation.title':
    'Probíhá přepočet cenového odhadu…',
  'atlas.unit_image_upload_modal.step.loading.estimate_generation.message':
    'Během okamžiku se dozvíte aktualizovaný odhad ceny nemovitosti.',

  'atlas.image_recognition.label.bathroom': 'Koupelna',
  'atlas.image_recognition.label.kitchen': 'Kuchyně',
  'atlas.image_recognition.label.bedroom': 'Ložnice',
  'atlas.image_recognition.label.dining_room': 'Jídelny',
  'atlas.image_recognition.label.empty_room': 'Prázdná místnost',
  'atlas.image_recognition.label.hallway': 'Chodba',
  'atlas.image_recognition.label.detail': 'Detail',
  'atlas.image_recognition.label.room': 'Pokoj',
  'atlas.image_recognition.label.other': 'Nerozpoznané fotky',

  // unit estimate
  'atlas.unit.estimate.title': 'Hodnota nemovitosti',
  'atlas.unit.estimate.estimate.title': 'Cenový odhad',
  'atlas.unit.estimate.tooltip':
    'Cenový odhad jsme vypočítali na základě dat o podobných bytech prodaných v okolí a zohlednili přitom zadané parametry bytu.<br></br>Ceny prodaných bytů vychází z aktuálních dat Katastru nemovitostí.',
  'atlas.unit.estimate.tooltip_improve_estimate':
    'Je rozmezí odhadu široké?<br></br>Doplňte chybějící údaje kliknutím na tlačítko Zpřesnit odhad.',
  'atlas.unit.estimate.yoy.title': 'Meziroční vývoj ceny',
  'atlas.unit.estimate.yoy.tooltip':
    'Procentuální vyjádření růstu či poklesu ceny za m² v této lokalitě.<br></br>Jsou porovnávány hodnoty v aktuálním měsíci mezi roky {from} a {to}.',
  'atlas.unit.estimate.price': '{low}&nbsp;Kč',
  'atlas.unit.estimate.price_range': '{low}&nbsp;-&nbsp;{high}&nbsp;Kč',
  'atlas.unit.estimate.price_mid': 'ø&nbsp;{avgPricePerSquareM}&nbsp;Kč/m²',
  'atlas.unit.estimate.percent_yoy': '{percents}&nbsp;%',
  'atlas.unit.estimate.price_yoy': '≈&nbsp;{price}&nbsp;Kč',
  'atlas.unit.estimate.price_yoy.chart.y_label': '{price}/m²',
  'atlas.unit.estimate.chart.heading': 'Vývoj ceny nemovitosti',
  'atlas.unit.estimate.entered_market': 'Inzerováno',
  'atlas.unit.estimate.sold': 'Prodalo se',
  'atlas.unit.estimate.estimate': 'Cenový odhad',
  'atlas.unit.estimate.selling_price': 'Inzerovaná cena',
  'atlas.unit.estimate.chart_value.predPriceMid': 'Odhadovaná cena',
  'atlas.unit.estimate.chart_value.sellingPrice': 'Inzerovaná cena',
  'atlas.unit.estimate.chart_value.soldPrice': 'Prodalo se za',
  'atlas.unit.estimate.error_title':
    'Při vytváření cenového odhadu došlo k chybě',
  'atlas.unit.estimate.subscribe_section.subtitle': 'Co je {cta}?',
  'atlas.unit.estimate.subscribe_section.subtitle_cta': 'sledování nemovitosti',
  'atlas.unit.estimate.subscribe_section.cta': 'Sledovat nemovitost',
  'atlas.unit.estimate.improve_estimate.tip':
    'Doplněním údajů získáte přesný cenový odhad.',
  'atlas.unit.estimate.improve_estimate.button': 'Zpřesnit odhad',

  // Unit last sale
  'atlas.unit.last_sale.title': 'Poslední prodej',
  'atlas.unit.last_sale.label.hidden': 'Skrytý',
  'atlas.unit.last_sale.tooltip':
    'Tento prodej je ve veřejném Atlasu cen skrytý, protože prodej byl realizován za cenu, která se významně liší od tržní ceny v lokalitě.',

  'atlas.unit.last_sale.sold.title': 'Prodejní cena',
  'atlas.unit.last_sale.sold.price': '{price}&nbsp;Kč',
  'atlas.unit.last_sale.sold.price_per_square_m': '{price}&nbsp;Kč/m²',

  'atlas.unit.last_sale.ad_diff.title': 'Rozdíl oproti inzerci',
  'atlas.unit.last_sale.ad_diff.tooltip':
    'Udává rozdíl mezi prodejní cenou a počáteční inzerovanou cenou. Záporná hodnota vyjadřuje slevu, zatímco kladná poukazuje na vyšší prodejní cenu oproti inzerci.',
  'atlas.unit.last_sale.ad_diff.price': '{price}&nbsp;Kč',
  'atlas.unit.last_sale.ad_diff.price_per_square_m': '{price}&nbsp;Kč/m²',
  'atlas.unit.last_sale.ad_diff.percentage': '{percentage}&nbsp;%',

  'atlas.unit.last_sale.date.title': 'Datum prodeje',

  'atlas.unit.last_sale.length.title': 'Délka prodeje',
  'atlas.unit.last_sale.length.days': `{days} {days, plural,
    one {den}
    few {dny}
    other {dní}
  }`,
  'atlas.unit.last_sale.length.months': `{months} {months, plural,
    one {měsíc}
    few {měsíce}
    other {měsíců}
  }`,

  'atlas.unit.last_sale.ad_seller.title': 'Prodáno makléřem',
  'atlas.unit.last_sale.ad_seller.unknown': 'Neznámý',

  // Unit history
  'atlas.unit_history.heading': 'Historie nemovitosti',
  'atlas.unit_history.button.show_more': 'Zobrazit další',
  // Unit history item
  'atlas.unit_history.item.price_per_square_m':
    'za {pricePerSquareM}&nbsp;Kč/m<sup>2</sup>',
  'atlas.unit_history.item.ppsm_changed_by_x_percents_to_ppsm_y':
    'o {priceChangeInPercents}&nbsp;% na {pricePerSquareM}&nbsp;Kč/m<sup>2</sup>',
  'atlas.unit_history.item.ppsm_changed_to_ppsm_y':
    'na {pricePerSquareM}&nbsp;Kč/m<sup>2</sup>',
  'atlas.unit_history.item.event.entered_market': 'Zahájení prodeje',
  'atlas.unit_history.item.event.price_decreased': 'Zlevněno',
  'atlas.unit_history.item.event.price_increased': 'Zdraženo',
  'atlas.unit_history.item.event.sold': 'Prodáno',
  'atlas.unit_history.item.including_dph': '(včetně {dph}% DPH)',
  'atlas.unit_history.item.label.hidden': 'Skrytý',
  'atlas.unit_history.item.tooltip':
    'Tento prodej je ve veřejném Atlasu cen skrytý, protože prodej byl realizován za cenu, která se významně liší od tržní ceny v lokalitě.',

  // Unit additional info
  'atlas.unit.additional_info.title': 'Podrobnosti o jednotce',
  'atlas.unit.additional_info.subtitle.basic': 'Základní údaje',
  'atlas.unit.additional_info.subtitle.conditions': 'Stav',
  'atlas.unit.additional_info.subtitle.amenities': 'Příslušenství',
  'atlas.unit.additional_info.subtitle.additional_info': 'Doplňující informace',
  'atlas.unit.additional_info.subtitle.building': 'Budova',
  'atlas.unit.additional_info.edit': 'Upravit údaje',
  'atlas.unit.additional_info.area': 'Podlahová plocha',
  'atlas.unit.additional_info.disposition': 'Dispozice',
  'atlas.unit.additional_info.ownership': 'Typ vlastnictví',
  'atlas.unit.additional_info.floor_number': 'Podlaží',
  'atlas.unit.additional_info.condition': 'Stav',
  'atlas.unit.additional_info.balcony': 'Balkon',
  'atlas.unit.additional_info.loggia': 'Lodžie',
  'atlas.unit.additional_info.terrace': 'Terasa',
  'atlas.unit.additional_info.cellar': 'Sklep',
  'atlas.unit.additional_info.garage': 'Garáž',
  'atlas.unit.additional_info.parking_space': 'Parkovací místa',
  'atlas.unit.additional_info.garden': 'Zahrada',
  'atlas.unit.additional_info.heating_kind': 'Topení',
  'atlas.unit.additional_info.accessibility': 'Bezbariérový přístup',

  // Unit additional info - ownership
  'atlas.unit.additional_info.ownership.private': 'Osobní',
  'atlas.unit.additional_info.ownership.collective': 'Družstevní',
  'atlas.unit.additional_info.ownership.national_or_municipal': 'Státní/obecní',
  'atlas.unit.additional_info.ownership.mixed': 'Smíšené',
  'atlas.unit.additional_info.ownership.other': 'Jiné',

  // Unit additional info - heating kind
  'atlas.unit.additional_info.heating_kind.central_internal':
    'Centrální domovní',
  'atlas.unit.additional_info.heating_kind.central_external':
    'Centrální dálkové',
  'atlas.unit.additional_info.heating_kind.local': 'Lokální',
  'atlas.unit.additional_info.heating_kind.other': 'Jiné (i bez topení)',
  'atlas.unit.additional_info.heating_kind.solid_fuels':
    'Vytápění tuhými palivy',
  'atlas.unit.additional_info.heating_kind.gas': 'Plynové topení',
  'atlas.unit.additional_info.heating_kind.electric': 'Elektrické topení',
  'atlas.unit.additional_info.heating_kind.heat_pump': 'Tepelná čerpadla',
  'atlas.unit.additional_info.heating_kind.stove_fireplace':
    'Lokální kamna a krby',

  // conditions
  'atlas.unit.additional_info.kitchen_condition': 'Stav kuchyně',
  'atlas.unit.additional_info.bathroom_condition': 'Stav koupelny',
  'atlas.unit.additional_info.rooms_condition': 'Stav pokojů',

  // Detail
  'atlas.detail.back': 'Zpět',
  'atlas.detail.close': 'Zavřít',
  'atlas.detail.panorama': 'Pohled z ulice',
  'atlas.detail.map': 'Mapa',

  // Building additional info
  'atlas.building.additional_info.title': 'Podrobnosti',
  'atlas.building.additional_info.edit': 'Upravit údaje',
  'atlas.building.additional_info.subtitle.areas': 'Plochy',
  'atlas.building.additional_info.subtitle.conditions': 'Stav',
  'atlas.building.additional_info.subtitle.amenities': 'Příslušenství',
  'atlas.building.additional_info.subtitle.parking': 'Parkování',
  'atlas.building.additional_info.subtitle.additional_info': 'Další informace',
  'atlas.building.additional_info.subtitle.building': 'Budova',
  'atlas.building.additional_info.floor_area': 'Podlahová plocha',
  'atlas.building.additional_info.land_area': 'Plocha pozemku',
  'atlas.building.additional_info.building_condition': 'Stav budovy',
  'atlas.building.additional_info.kitchen_condition': 'Stav kuchyně',
  'atlas.building.additional_info.bathroom_condition': 'Stav koupelny',
  'atlas.building.additional_info.pool': 'Bazén',
  'atlas.building.additional_info.sauna': 'Sauna',
  'atlas.building.additional_info.fireplace': 'Krb',
  'atlas.building.additional_info.pergola': 'Pergola',
  'atlas.building.additional_info.solar_panels': 'Solární panely',
  'atlas.building.additional_info.heat_pump': 'Tepelné čerpadlo',
  'atlas.building.additional_info.garage': 'Garáž',
  'atlas.building.additional_info.covered_parking_space':
    'Krytá parkovací místa',
  'atlas.building.additional_info.uncovered_parking_space':
    'Nekrytá parkovací místa',
  'atlas.building.additional_info.house_separation': 'Poloha domu',
  'atlas.building.additional_info.nearby_traffic_routes':
    'Rušná dopravní tepna',
  'atlas.building.additional_info.construction_kind': 'Typ konstrukce',
  'atlas.building.additional_info.finished_at': 'Rok výstavby',
  'atlas.building.additional_info.finished_at_interval': 'Rok výstavby',
  'atlas.building.additional_info.elevator': 'Výtah',
  'atlas.building.additional_info.floors': 'Počet podlaží',
  'atlas.building.additional_info.heating_kind': 'Topení',
  'atlas.building.additional_info.energy_performance':
    'Energ. náročnost budovy',

  // Construction kinds
  'atlas.building.additional_info.construction_kind.brick_cinder_block':
    'Cihla',
  'atlas.building.additional_info.construction_kind.stone': 'Cihla',
  'atlas.building.additional_info.construction_kind.brick_stone': 'Cihla',
  'atlas.building.additional_info.construction_kind.panel': 'Panel',
  'atlas.building.additional_info.construction_kind.mudbrick': 'Cihla',
  'atlas.building.additional_info.construction_kind.wood': 'Dřevo',
  'atlas.building.additional_info.construction_kind.other': 'Jiný',
  'atlas.building.additional_info.construction_kind.brick_stone_cinder_block':
    'Cihla',
  'atlas.building.additional_info.construction_kind.monolith': 'Monolit',

  // pool types
  'atlas.building.additional_info.pool.sunken': 'Zapuštěný',
  'atlas.building.additional_info.pool.semi_sunken': 'Polozapuštěný',
  'atlas.building.additional_info.pool.above_ground': 'Nadzemní',

  // sauna types
  'atlas.building.additional_info.sauna.basic': 'Základní',
  'atlas.building.additional_info.sauna.luxurious': 'Luxusní',

  // house fireplace type
  'atlas.building.additional_info.fireplace.burner_stove': 'Krbová kamna',
  'atlas.building.additional_info.fireplace.built_in': 'Zabudovaný krb',
  'atlas.building.additional_info.fireplace.tiled':
    'Kachlová kamna se sporákem nebo pecí',

  // house pergola type
  'atlas.building.additional_info.pergola.classic': 'Klasická',
  'atlas.building.additional_info.pergola.glassed': 'Zasklená',
  'atlas.building.additional_info.pergola.bio_climatic': 'Bioklimatická',

  // solar panels purpose
  'atlas.building.additional_info.solar_panels_purpose.electricity_generation':
    'Výroba elektřiny',
  'atlas.building.additional_info.solar_panels_purpose.water_heating':
    'Ohřev vody',
  'atlas.building.additional_info.solar_panels_purpose.electricity_generation_water_heating':
    'Obojí',

  // house heat pump type
  'atlas.building.additional_info.heat_pump.air_air': 'Vzduch-vzduch',
  'atlas.building.additional_info.heat_pump.air_water': 'Vzduch-voda',
  'atlas.building.additional_info.heat_pump.water_water': 'Voda-voda',
  'atlas.building.additional_info.heat_pump.ground_water': 'Země-voda',

  // house nearby traffic route
  'atlas.building.additional_info.nearby_traffic_routes.main_road':
    'Silnice / Dálnice',
  'atlas.building.additional_info.nearby_traffic_routes.railway': 'Železnice',
  'atlas.building.additional_info.nearby_traffic_routes.airport': 'Letiště',

  // house separation type
  'atlas.building.additional_info.house_separation.stand_alone':
    'Samostatně stojící',
  'atlas.building.additional_info.house_separation.terraced':
    'Řadový / v bloku',

  // Heating kinds
  'atlas.building.additional_info.heating_kind.central_internal':
    'Centrální domovní',
  'atlas.building.additional_info.heating_kind.central_external':
    'Centrální dálkové',
  'atlas.building.additional_info.heating_kind.local': 'Lokální',
  'atlas.building.additional_info.heating_kind.other': 'Jiné (i bez topení)',

  // Elevator
  'atlas.building.additional_info.elevator.has_elevator': 'Ano',
  'atlas.building.additional_info.elevator.no_elevator': 'Ne',

  // Energy performance
  'atlas.building.additional_info.energy_performance.A': 'A',
  'atlas.building.additional_info.energy_performance.B': 'B',
  'atlas.building.additional_info.energy_performance.C': 'C',
  'atlas.building.additional_info.energy_performance.D': 'D',
  'atlas.building.additional_info.energy_performance.E': 'E',
  'atlas.building.additional_info.energy_performance.F': 'F',
  'atlas.building.additional_info.energy_performance.G': 'G',

  // Related estates
  'atlas.related_estates.title': 'Související nemovitosti',
  'atlas.related_estates.building': 'Stavební objekt',
  'atlas.related_estates.parcel': 'Parcela',
  'atlas.related_estates.show_all': 'Zobrazit vše ({count})',

  // Navbar
  'atlas.nav.cta': 'Chci prodat',

  // Filters control
  'atlas.filters_control.button': 'Filtrace',

  // atlas map cursor
  'atlas.map_cursor.text': 'zobrazit detail',

  'atlas.month_with_year': '{month} {year}',
  'atlas.sold_after_x_months': `Prodáno za {months}&nbsp;{months, plural,
    one {měsíc}
    few {měsíce}
    other {měsíců}
  }`,
  'atlas.sold_after_x_months_short': 'Prodáno za {months}&nbsp;měs.',
  'atlas.sold_after_less_than_15_days': 'Prodáno za &lt;15&nbsp;dní',

  // unit estimate subscribe modal
  'atlas.unit_estimate_subscribe_modal.title': 'Mějte přehled o ceně!',
  'atlas.unit_estimate_subscribe_modal.subtitle':
    'Každý měsíc se ZDARMA dozvíte:',
  'atlas.unit_estimate_subscribe_modal.benefits.1':
    'Co se v okolí prodalo a za kolik',
  'atlas.unit_estimate_subscribe_modal.benefits.2': 'Aktuální odhad ceny bytu',
  'atlas.unit_estimate_subscribe_modal.cta': 'Nastavit sledování',
  'atlas.unit_estimate_subscribe_modal.cta.state.sending': 'Odesílání...',
  'atlas.unit_estimate_subscribe_modal.inputs.email.label':
    'Zadejte váš e-mail:',
  'atlas.unit_estimate_subscribe_modal.inputs.email.placeholder':
    'např. jan@novak.cz',
  'atlas.unit_estimate_subscribe_modal.unit_info.unit_number':
    'Jednotka č. {unitCode}',
  'atlas.unit_estimate_subscribe_modal.unit_info.unknown_unit':
    'Neznámá jednotka',
  'atlas.unit_estimate_subscribe_modal.success.done': 'Hotovo.',
  'atlas.unit_estimate_subscribe_modal.success.success_message':
    'Přihlásili jste se ke sledování ceny bytu:',
  'atlas.unit_estimate_subscribe_modal.success.where_will_emails_be_sent':
    'Přehled o ceně budete dostávat na e-mail:',
  'atlas.unit_estimate_subscribe_modal.success.back_to_unit_detail':
    'Zpět na detail jednotky',

  // Universal
  'atlas.area_range': '{areaFrom}&#8209;{areaTo}&nbsp;m<sup>2</sup>',
  'atlas.area': '{area}&nbsp;m<sup>2</sup>',
  'atlas.parking_count': '{count}&nbsp;stání',

  // Additional info editation
  'atlas.building_editation.title': 'Úprava údajů o budově',
  'atlas.building_editation.description':
    'Doplňte či opravte údaje a zlepšíte tím přesnost odhadů cen bytů v tomto domě.',
  'atlas.additional_info_editation.cancel': 'Zrušit úpravy',
  'atlas.additional_info_editation.continue': 'Uložit změny',
  'atlas.additional_info_editation.error':
    'Při ukládání došlo k chybě, zkuste to prosím znovu později.',
  'atlas.additional_info_editation.yes_no_select.yes': 'Ano',
  'atlas.additional_info_editation.yes_no_select.no': 'Ne',

  // Building detail editation fields
  // areas section
  'atlas.building_editation.areas.title': 'Plochy',

  // areas section - floor area
  'atlas.building_editation.floor_area.title': 'Podlahová plocha',
  'atlas.building_editation.floor_area.title.tooltip':
    'Součet vnitřních ploch hlavní budovy <b>včetně</b> sklepu, půdy a neobývaných prostor.',
  'atlas.building_editation.floor_area.error.min':
    'Zadejte, prosím, výměru plochy alespoň {minFloorArea} m<sup>2</sup>',
  'atlas.building_editation.floor_area.error.max':
    'Maximální výměra je {maxFloorArea} m<sup>2</sup>. Prosím, upravte údaj.',

  // areas section - land area
  'atlas.building_editation.land_area.title': 'Plocha pozemku',
  'atlas.building_editation.land_area.title.tooltip':
    'Zadejte celkovou plochu pozemků včetně zastavěných ploch.',

  // conditions section
  'atlas.building_editation.conditions.title': 'Stavy',
  'atlas.building_editation.conditions.building_condition': 'Stav budovy',
  'atlas.building_editation.conditions.kitchen_condition': 'Stav kuchyně',
  'atlas.building_editation.conditions.bathroom_condition': 'Stav koupelny',

  // accessories section
  'atlas.building_editation.accessories.title': 'Příslušenství',
  'atlas.building_editation.accessories.subtitle':
    'Vyberte příslušenství, které k domu náleží a upřesněte jeho detaily:',
  'atlas.building_editation.accessories.placeholder': '- vyberte typ',
  'atlas.building_editation.accessory_type.required':
    'Vyberte, prosím, jednu z možností.',
  'atlas.building_editation.pool.title': 'Bazén',
  'atlas.building_editation.sauna.title': 'Sauna',
  'atlas.building_editation.fireplace.title': 'Krb',
  'atlas.building_editation.pergola.title': 'Pergola',
  'atlas.building_editation.heat_pump.title': 'Tepelné čerpadlo',
  'atlas.building_editation.solar_panels.title': 'Solarní panely',
  'atlas.building_editation.solar_panels.area.title': 'Plocha panelů:',
  'atlas.building_editation.solar_panels.area.error.positive':
    'Zadejte prosím kladnou plochu',

  // parking section
  'atlas.building_editation.parking.title': 'Parkování',
  'atlas.building_editation.parking.subtitle':
    'Vyberte typ a uveďte <b>počet stání</b>:',
  'atlas.building_editation.parking.garage': 'Garáž',
  'atlas.building_editation.parking.covered_parking_space':
    'Kryté parkovací místo',
  'atlas.building_editation.parking.uncovered_parking_space':
    'Nekryté parkovací místo',
  'atlas.building_editation.parking.fields.errors.min': 'Minimum je 1.',
  'atlas.building_editation.parking.fields.errors.number_required':
    'Doplňte, prosím, počet stání.',

  // additional info section
  'atlas.building_editation.additional_info.title': 'Další informace',
  'atlas.building_editation.house_separation.title': 'Poloha domu',

  'atlas.building_editation.nearby_traffic_routes.title':
    'Rušná dopravní tepna v okolí',

  'atlas.building_editation.nearby_traffic_routes.error.length':
    'Vyberte, prosím, jednu z možností.',

  'atlas.building_editation.building_type_select.label': 'Typ budovy',
  'atlas.building_editation.building_type_select.info':
    'Změníte-li typ budovy, mohou být současně změněny i související údaje uvedené níže.',
  'atlas.building_editation.finished_at.title': 'Rok výstavby',
  'atlas.building_editation.finished_at.exact_finished_at': 'Znám přesný rok',
  'atlas.building_editation.finished_at.error.min':
    'Rok výstavby nesmí být dříve než 1900.',
  'atlas.building_editation.finished_at.error.max':
    'Rok výstavby nesmí být později než {year}.',

  'atlas.building_editation.construction_kind.title': 'Typ konstrukce',
  'atlas.building_editation.construction_kind.error.invalid':
    'Vyberte prosím platnou možnost.',

  'atlas.building_editation.elevator.title': 'Výtah v budově',

  'atlas.building_editation.floors_count.title': 'Počet podlaží',
  'atlas.building_editation.floors_count.error.min':
    'Počet podlaží nesmí být menší než 1',
  'atlas.building_editation.floors_count.error.max':
    'Počet podlaží nesmí být vyšší než 29',

  'atlas.building_editation.energy_performance.title':
    'Energ. náročnost budovy',
  'atlas.building_editation.energy_performance.error.invalid':
    'Vyberte prosím platnou možnost.',

  'atlas.building_editation.heating_kind.title': 'Topení',
  'atlas.building_editation.heating_kind.error.invalid':
    'Vyberte prosím platnou možnost.',

  // unit editation
  'atlas.unit_editation.title': 'Zpřesnění cenového odhadu',
  'atlas.unit_editation.description':
    'Doplňte či opravte údaje o bytové jednotce a získáte přesnější cenový odhad <b>až o 30%.</b>',
  'atlas.unit_editation.unit_number':
    'Jednotka č. {buildingNumber}/{unitNumber}',

  // section titles
  'atlas.unit_editation.basic_info.title': 'Základní informace',
  'atlas.unit_editation.flat_condition.title': 'Stav bytu',
  'atlas.unit_editation.accessories.title': 'Příslušenství',
  'atlas.unit_editation.additional_info.title': 'Doplňující informace',
  'atlas.unit_editation.building.title': 'Budova',

  // section descriptions
  'atlas.unit_editation.accessories.description':
    'Vyberte příslušenství, které k bytu náleží, a doplňte výměru (m²):',
  'atlas.unit_editation.parking.description':
    'Náleží-li k bytu garáž nebo venkovní parkovací místo, uveďte jej (vč. počtu míst):',

  // section labels
  'atlas.unit_editation.basic_info.label': '+6% zpřesnění',
  'atlas.unit_editation.flat_condition.label': '+15% zpřesnění',
  'atlas.unit_editation.accessories.label': '+4% zpřesnění',
  'atlas.unit_editation.building.label': '+5% zpřesnění',

  // field titles
  'atlas.unit_editation.floor_area.title': 'Podlahová plocha',
  'atlas.unit_editation.ownership.title': 'Typ vlastnictví',
  'atlas.unit_editation.heating_kind.title': 'Topení',
  'atlas.unit_editation.disposition.title': 'Dispozice',
  'atlas.unit_editation.floor_number.title': 'Číslo podlaží',
  'atlas.unit_editation.floor_count.title': 'Počet podlaží v budově',
  'atlas.unit_editation.accessibility.title': 'Bezbariérový přístup',
  'atlas.unit_editation.balcony.title': 'Balkon',
  'atlas.unit_editation.loggia.title': 'Lodžie',
  'atlas.unit_editation.terrace.title': 'Terasa',
  'atlas.unit_editation.cellar.title': 'Sklep',
  'atlas.unit_editation.garden.title': 'Zahrada',
  'atlas.unit_editation.garage.title': 'Garáž',
  'atlas.unit_editation.parking_space.title': 'Parkovací místo',
  'atlas.unit_editation.flat_condition.kitchen_condition': 'Stav kuchyně',
  'atlas.unit_editation.flat_condition.bathroom_condition': 'Stav koupelny',
  'atlas.unit_editation.flat_condition.rooms_condition': 'Stav místností',

  // tooltips
  'atlas.unit_editation.balcony.tooltip':
    '<b>Balkon</b> je předsazená konstrukce se zábradlím, která přečnívá přes obvodové zdi stavby.',
  'atlas.unit_editation.loggia.tooltip':
    '<b>Lodžie</b> narozdíl od balkonu z obvodové zdi nevystupuje. Jde o zastropený prostor v budově.',
  'atlas.unit_editation.terrace.tooltip':
    '<b>Terasa</b> je venkovní část stavby, umístěná nad úrovní terénu. Bývá větší než balkon a liší se i tím, že nevystupuje z hmoty budovy. Časté jsou střešní terasy.',
  'atlas.unit_editation.floor_number.tooltip':
    'Víte, že podlaží není to samé jako patro? U podlaží rozlišujeme, zda se jedná o nadzemní podlaží (NP) nebo podzemní podlaží (PP). Nám stačí uvést číslo NP.<br></br><b>Nápověda:</b><br></br>Přízemí = 1.NP (uveďte „1“)<br></br>1.patro = 2.NP (uveďte „2“)<br></br>2.patro = 3.NP (uveďte „3“) apod.',
  'atlas.unit_editation.parking_space.tooltip':
    'Pokud vlastníte spolu s bytem <b>parkovací stání</b> u domu (např. ve vnitrobloku) nebo <b>garážové stání</b> přímo v budově, uveďte ho zde pro přesnější cenový odhad.',
  'atlas.unit_editation.floor_area.tooltip':
    'Do podlahové plochy bytu se započítává veškerá vnitřní plocha bytu včetně všech zastavěných ploch, jako jsou nosné stěny i příčky, sloupy, pilíře, vestavěné skříně apod.',

  // errors
  'atlas.info_editation.errors.default': 'Chybná hodnota.',
  'atlas.info_editation.errors.min': 'Hodnota nesmí být menší než {value}.',
  'atlas.info_editation.errors.positive': 'Hodnota nesmí být menší než 1.',
  'atlas.info_editation.errors.max': 'Hodnota nesmí být vyšší než {value}.',
  'atlas.info_editation.errors.required': 'Vyplňte prosím hodnotu.',

  // field specific errors
  'atlas.unit_editation.floor_number.errors.not_zero': 'Podlaží nesmí být 0.',
  'atlas.unit_editation.floor_number.errors.min':
    'Podlaží nesmí být menší než -3.',
  'atlas.unit_editation.floor_number.errors.max':
    'Podlaží nesmí být vyšší než počet pater v budově.',

  'atlas.price_per_square_m': '{value}/m<sup>2</sup>',
  'atlas.open_map_button': 'Zobrazit mapu',

  // conversion bar
  'atlas.conversion_bar.cta.find_out_interest': 'Zjistit zájem',
  'atlas.conversion_bar.similar_flat_with_us': 'Podobný byt s námi aktuálně',
  'atlas.conversion_bar.count_people': 'hledá 65 zájemců',
  'atlas.conversion_bar.cta.calculate_price': 'Spočítat odhad ceny',
  'atlas.conversion_bar.find_out_price':
    'Zjistěte cenu <br></br>nemovitosti online',
};
